<template>
	<v-dialog v-model="dialog" persistent max-width="500">
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">{{ title }}</v-toolbar-title>
			</v-toolbar>
			<v-card-text class="py-2">
				{{ message }}
			</v-card-text>
			<v-card-actions>
				<v-row no-gutters>
					<v-col cols="5" class="text-center">
						<v-btn @click="sendYes">はい</v-btn>
					</v-col>
					<v-col cols="2" />
					<v-col cols="5" class="text-center">
						<v-btn @click="closeDialog">いいえ</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
			<!-- <v-card-actions>
				<v-row no-gutters>
					<v-col cols="4" />
					<v-col cols="4"> </v-col>
					<v-col cols="4">
						<v-row no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="closeDialog"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions> -->
		</v-card>
	</v-dialog>
</template>
<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import rules from "../../../helper/rules"
import common from "../../../helper/common"
export default {
	props: {},
	data() {
		return {
			dialog: false,
			title: "",
			message: "",
		}
	},
	methods: {
		sendYes() {
			this.$emit("chose")
			this.closeDialog()
		},
		openDialog(title, message) {
			this.dialog = true
			this.title = title
			this.message = message
		},
		closeDialog() {
			this.dialog = false
			this.title = ""
			this.message = ""
		},
	},
	watch: {},
}
</script>
<style scoped></style>
